<template>
    <div class="wxl-notify-view" @click.stop="$emit('click')">
        <div class="text" :style="getstyle()">{{ text }}
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'wxl-notify-view',
        data: function() {
            return {
            }
        },
        methods: {
            getstyle: function() {
                return {
                    fontSize: this.fontsize + 'px'
                }
            }
        },
        components: {

        },
        props: {
            text: String,
            fontsize: {
                type: Number,
                default: 72
            }
        },
        mounted: function() {
        }
    }
</script>
<style lang="less" scoped>
    @import '@/styles/position.less';
    @import '@/styles/color.less';
    .wxl-notify-view {
        .absolute();
        user-select: none;
    }

    .wxl-notify-view .text {
        color: @grey;
        text-align: center;
        position: relative; /*必须指定position，值也可以为absolute*/
        top: 50%;
        transform: translateY(-50%);
    }
</style>
